import { Routes } from '@angular/router';
import {
	createAuthRoutes,
	createVideoPopoutRoute,
	featureSettingsResolver,
	raceActiveGuard,
} from '@vbrick/vb-lxp-lib';
import {
	LivestreamViewComponent,
	VbLxpFullTimingPageComponent,
	VbLxpMapPageComponent,
	VbLxpPreRacePageComponent,
} from '@vbrick/vb-lxp-lib';

export const routes: Routes = [
	createVideoPopoutRoute(),
	{
		path: '',
		component: LivestreamViewComponent,
		canActivate: [raceActiveGuard],
		resolve: {
			featureSettings: featureSettingsResolver,
		},
		data: {
			showLayoutControls: true,
			showTimingControl: true,
			showTwitchStreamControl: true,
			showChatControl: true,
			showMapControl: false,
			showPanelMapControl: true,
			showRaceControlControl: true,
		},
	},
	...createAuthRoutes(),
	{
		path: 'full-timing',
		component: VbLxpFullTimingPageComponent,
		data: {
			showLayoutControls: false,
			showTimingTowerControl: false,
			showChatControl: false,
			showMapControl: true,
			showRaceControlControl: true,
		},
	},
	{
		path: 'pre-race',
		component: VbLxpPreRacePageComponent,
		data: {
			showLayoutControls: false,
			showTimingTowerControl: false,
			showChatControl: false,
			showMapControl: false,
		},
	},
	{
		path: 'map-popout',
		loadComponent: () => Promise.resolve(VbLxpMapPageComponent),
		data: {
			showHeader: false,
			showFooter: false,
			showLayoutControls: false,
			showTimingControl: false,
			showTimingTowerControl: false,
			showChatControl: false,
			showMapControl: false,
			showRaceClassControl: false,
		},
	},
];
